import { CustomerSupportContacts } from 'typings/brands'

const creditServiceNumber = '1-855-659-9789'

const customerSupport: CustomerSupportContacts = {
  contactUsProx: '',
  contactUsBrc: creditServiceNumber,
  contactUsBrcPlcc: creditServiceNumber,
  contactUsBrcDc: creditServiceNumber,
  contactUsDirectCustomer: creditServiceNumber,
  closeAccountService: creditServiceNumber,
  creditServiceNumber,
  getCSRNumber() {
    return creditServiceNumber
  },
  membershipServiceNumber: creditServiceNumber,
  systemErrorPageContacts: {
    en: [`Private label customers: ${creditServiceNumber}`],
    es: []
  },
  assistanceAlertContacts: [creditServiceNumber]
}

export default customerSupport
